import { compose, createStore, applyMiddleware, combineReducers } from 'redux';
import { createEpicMiddleware, combineEpics } from 'redux-observable';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';

import { reducers, epics } from './utils/compose';
import buildInitialState from './buildInitialState';

// utils
import { finalHandleReducers } from './utils/handleReducers';
import { finalHandleEpics } from './utils/handleEpics';

/**
 * Creates a redux store
 * @param {object} reducers
 * @param {object} epics
 * @param {object} data
 */
export function finalCreateStore(reducers, epics, initialState = {}) {
  let appReducers = { ...reducers };
  let appEpics = { ...epics };

  const epicMiddleware = createEpicMiddleware();
  const logger = createLogger({ collapsed: true });

  let middleware = [epicMiddleware];
  if (process.env.NODE_ENV === 'development') middleware = [...middleware /*, logger*/];

  // Initialize store
  appReducers = finalHandleReducers(appReducers);
  appEpics = finalHandleEpics(appEpics);

  const store = createStore(
    combineReducers(appReducers),
    initialState,
    compose(composeWithDevTools(applyMiddleware(...middleware)))
  );

  epicMiddleware.run(combineEpics(...Object.values(appEpics)));

  return store;
}

const store = finalCreateStore(reducers, epics, buildInitialState());

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    module.hot.accept('./utils/compose', () => {
      store.replaceReducer(reducers);
    });
  }
}

export default store;
